import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Notify, PersonelList, PersonelLogin, UserPermissionsDto } from '../models/Personel';
import { AuthService } from '../services/auth.service';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { KullaniciPaneliComponent } from '../admin/kullanici-paneli/kullanici-paneli.component';
import { PdfYukleComponent } from '../admin/pdf-yukle/pdf-yukle.component';
import { NotifymodalComponent } from '../notifymodal/notifymodal.component';
import { MatHeaderRowDef } from '@angular/material/table';
import { PersonelService } from '../services/personel.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalComponent } from '../modal/modal.component';




@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],

})
export class DashboardComponent implements OnInit {

  public leaps: DashboardLeap[] = [];
  public user: PersonelLogin;
  public isUser: boolean;
  public isFirstPass: boolean;
  public nots: Notify[];
  public izinler: UserPermissionsDto[];
  public isReadExist: boolean = false;




  constructor(
    private router: Router,
    private authService: AuthService,
    public dialog: MatDialog,
    private personelService: PersonelService,
    private spinner: NgxSpinnerService,

  ) {

    this.user = this.authService.getLoginDetails();

    //console.log(this.user.first_login);

    if (this.user.first_login == "True") {
      this.isFirstPass = true;
    }
    else {
      this.isFirstPass = false;
    }

    //console.log(this.isFirstPass);

    if (this.user.user_role == "Admin") {
      this.isUser = false;
      this.leaps.push({
        'name': "Kullanıcı Listesi",
        'path': "/dashboard/kullaniciPaneli",
      });
      this.leaps.push({
        'name': "PDF Yükle",
        'path': "/dashboard/pdfYukle",
      });
    } else {

      this.spinner.show();
      this.personelService.getUserPermissions().subscribe(res => {
        //console.log(res);
        this.izinler = res;
      },
        error => {
          this.dialog.open(NotifymodalComponent, {
            data: {
              isSuccess: false,
              text: error.error.error,
              subject: "İzin Yükleme"
            }
          });
        });

      this.isUser = true;
      this.leaps.push({
        'name': "Bordro",
        'path': "/dashboard/bordro",
      });
      this.leaps.push({
        'name': "Puantaj",
        'path': "/dashboard/puantaj",
      });
      this.leaps.push({
        'name': "Ücret Hesap Pusulası",
        'path': "/dashboard/hesap",
      });

      this.personelService.getMessageNotify().subscribe(res => {
        //console.log(res);

        this.nots = res;
        for(let not of this.nots){
          //console.log(not.IsRead);
          if (not.IsRead == null) {
            this.isReadExist = true;
            this.dialog.open(ModalComponent, {
              data: not,
            });
            break;
          }
        }

        this.spinner.hide();
      }, error => {
        this.spinner.hide();
        this.dialog.open(NotifymodalComponent, {
          data: {
            isSuccess: false,
            text: error.error.error,
            subject: "Notification Yükleme"
          }
        });
      });


    }
  }

  ngOnInit(): void {

  }

  goHome(){
    this.router.navigate(['/dashboard']);
  }

  goChangePass() {
    this.router.navigate(['/dashboard/sifreDegistir']);
  }

  goMessages() {
    this.router.navigate(['/dashboard/mesajlar']);
  }

  outClick(): void {

    this.authService.logout();
    this.personelService.logoutServerSide();

    this.router.navigate(['']);

  }

  goUrl(leap: DashboardLeap) {
    this.router.navigate([leap.path]);
  }
/*
  modalTest() {
    this.dialog.open(NotifymodalComponent, {
      data: {
        text: "Test Yazısıdır.",
        subject: "Test Başlığı"
      }
    }).afterClosed().subscribe(() => {

    });
  }*/

}

export class DashboardLeap {
  name: string;
  path: string;
}